import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Container } from "@mui/material";
export const AppContainer = ({ children }) => {
    return (_jsx(Container, { sx: {
            maxWidth: "100% !important",
            minHeight: "80dvh",
            position: "relative",
        }, children: _jsx(Box, { sx: {
                margin: "0 auto",
                maxWidth: (theme) => ({
                    xs: theme.breakpoints.values.sm,
                    md: theme.breakpoints.values.lg,
                }),
                flex: "1 0 auto",
            }, children: children }) }));
};
//# sourceMappingURL=AppContainer.js.map